// ** Redux Imports
/* eslint-disable */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { commissionsByUser } from "../../../../api/Api";

export const getAllCommissionByUser = createAsyncThunk(
  "appCommission/getAllCommissionByUser",
  async (query) => {
    try {
      return commissionsByUser.getAll(query);
    } catch (error) {
      console.error(error);
    }
  }
);

export const getCommission = createAsyncThunk(
  "appCommission/getCommission",
  async (id) => {
    try {
      return commissionsByUser.getCommission(id);
    } catch (error) {
      console.error(error);
    }
  }
);

export const commissionActive = createAsyncThunk(
  "appCommission/commissionActive",
  async (value) => {
    return commissionsByUser.active(value);
  }
);

export const addCommission = createAsyncThunk(
  "appCommission/addCommission",
  async (values) => {
    try {
      return commissionsByUser.create(values);
    } catch (error) {
      console.error(error);
    }
  }
);

export const editCommission = createAsyncThunk(
  "appCommission/editCommission",
  async (values) => {
    return commissionsByUser.edit(values);
  }
);

export const deleteCommission = createAsyncThunk(
  "appCommission/deleteCommission",
  async (id) => {
    return commissionsByUser.remove(id);
  }
);

export const appCommissionSlice = createSlice({
  name: "appCommission",
  initialState: {
    commissionsByUser: [],
    metaData: {},
    commissionsByUserFetch: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllCommissionByUser.fulfilled, (state, action) => {
      if (action.payload.status !== 200) {
        state.commissionsByUser = [];
        state.metaData = {};
        state.commissionsByUserFetch = false;
        return;
      }
      state.metaData = action.payload.data.metaData;
      state.commissionsByUser = action.payload?.data?.data;
      state.commissionsByUserFetch = true;
    });
  },
});

export default appCommissionSlice.reducer;
